<template>
  <div class="gameList">
      <table class="table table-hover table-sm mt-2">
        <thead>
          <tr>
            <th>Nom</th>
            <th class="text-right">Créateur</th>
            <th class="text-right">Tour</th>
            <th class="text-right">Début</th>
            <th class="text-right">Fin</th>
            <th class="text-right">Joueurs</th>
            <th class="text-right">Temps par tour</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <access-game-list-row v-for="game in games"
          v-bind:key="game.id"
          v-bind:players="getGamePlayers(game.id)"
          v-bind:game="game"/>
        </tbody>
      </table>
  </div>
</template>

<script>
import AccessGameListRow from './AccessGameListRow';

export default {
  name: 'AccessGameList',
  components: { AccessGameListRow },
  props: {
    games: {
      type: Array,
      required: true,
    },
    players: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      gamePassword: undefined,
    };
  },
  methods: {
    getGamePlayers(activeGameId) {
      return this.players.filter(p => p.activeGameId === activeGameId);
    },
  },
};
</script>

<style scoped>
.gameList{
  background-color: white;
}
th{
  color: #757575;
}
</style>



// WEBPACK FOOTER //
// src/components/AccessGameList.vue